import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { REGULAR_FONT_FAMILY } from '../../utils/fonts';
import { FontText } from './FontText';

export const Loading: React.FC = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  const styles: Record<string, React.CSSProperties> = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: theme.colors.background,
    },
    spinner: {
      width: 50,
      height: 50,
      border: `3px solid ${theme.colors.overlay}`,
      borderTop: `3px solid ${theme.colors.accent}`,
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    text: {
      marginTop: 20,
      color: theme.colors.textSecondary,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.spinner} />
      <FontText style={styles.text}>{t('loading')}</FontText>
    </div>
  );
};
